//存放数据
const state = {
  lang: 'zh-CN',//语言包
  localLang: {},//语言包映射表
}
//修改数据，调用方式this.$store.commit('increment', 2)
const mutations = {
  //设置语言包
  initLocalLang(state, { name, value }) {
    if (state.localLang[name] === undefined) {
      state.localLang[name] = {};
    }
    // console.log("----------设置语言包", name, value);
    // console.log("----------state", state);
    state.localLang[name] = value;
  },
  //更换语言包
  changeLang(state, name) {
    state.lang = name;
  }
}
//专门处理异步，调用方式：this.$store.dispatch('fetchUser')
const actions = {

}
//state 的计算属性，像 computed，使用方式：this.$store.getters.isLogin
const getters = {
  getLang(state) {
    return state.lang;
  },
  getLocalLang(state) {
    return (langPackage) => {
      if (state.localLang[langPackage]) {
        return state.localLang[langPackage];
      }
      return;
    }
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}